module.exports = __webpack_public_path__ + "img/daizy_peak.5f30194a.jpg";